import { toHumanizedList } from "common/utils/strings";

/**
 * Formats product-line names as a singular or plural controlled-substance clause, e.g.
 * "Gabapentin is a controlled substance" or
 * "Gabapentin and Proin are controlled substances".
 */
export const getControlledProductLinesText = (productLineNames: string[]): string =>
  `${toHumanizedList(productLineNames)} ${
    productLineNames.length === 1 ? "is a controlled substance" : "are controlled substances"
  }`;
